export class MyRatings {
    id: string;
    postId: string;
    rating: any;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/myRatingsModel.ts